import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';
import { buildLocationAPIPayload } from 'store/utils/userLocation.utils';

export const airportsApi = createApi({
  reducerPath: 'airportsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['AirportWeather'],
  endpoints: (builder) => ({
    getAirportConditionsbyState: builder.query({
      query: () => ({
        url: '/v2/custom-weather/airport/conditions',
      }),
      transformResponse: (response) => response?.result || [],
      providesTags: ['AirportWeather', { type: 'AirportWeather', id: 'CONDITIONS' }],
    }),
    getAirportDelayForecast: builder.query({
      query: (location) => ({
        url: '/v2/custom-weather/forecast/airport-delays',
        params: buildLocationAPIPayload(location),
      }),
      transformResponse: (response) => response?.result || [],
      providesTags: ['AirportWeather', { type: 'AirportWeather', id: 'DELAYS' }],
    }),
  }),
});

export const { useGetAirportConditionsbyStateQuery, useGetAirportDelayForecastQuery } = airportsApi;
